import {
	getGuestCreditCards,
	CreditCardList,
	GetGuestCreditCardsParams,
} from "@/api/credit-cards/credit-cards";
import { QueryOptionsWithoutKeyAndFn } from "@/types/types";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { creditCardKeys } from "./keys";

export function creditCardsQueryOptions(
	params: GetGuestCreditCardsParams,
	options?: QueryOptionsWithoutKeyAndFn<CreditCardList>,
) {
	return queryOptions({
		queryFn: () => getGuestCreditCards(params),
		queryKey: creditCardKeys.list(params),
		refetchOnWindowFocus: false,
		...options,
	});
}

export default function useGetCreditCards(
	params: GetGuestCreditCardsParams,
	options?: QueryOptionsWithoutKeyAndFn<CreditCardList>,
) {
	return useQuery(creditCardsQueryOptions(params, options));
}
